<div class="panel">
    <div class="title">
        <div class="header">{{ "widgetMarket.title" | t }}</div>
        <small class="text-muted">{{ "widgetMarket.subtitle" | t }}</small>
    </div>
    <div class="search-bar">
        <input
            type="text"
            class="form-control form-control-sm"
            [placeholder]="'widgetMarket.searchPlaceholder' | t"
            (debounce-input-event)="filter($event)"
            inputTooltip
        />
    </div>
    <div class="available-widgets">
        @for (widget of filteredMarketWidgets; track widget) {
            <div class="widget" draggable="true" (dragstart)="dragStartHandler($event, widget)">
                <div class="widget-image">
                    @if (widget.icon) {
                        <i [class]="widget.icon + ' fa-fw'"></i>
                    }
                </div>
                <div class="widget-info">
                    <div class="widget-title">{{ catalogKey(widget.title) | t }}</div>
                    <div class="widget-description">{{ catalogKey(widget.description) | t }}</div>
                </div>
            </div>
        }
    </div>
</div>
